import React from 'react';
import MolLink from '../../Basepage/parts/Menu/MolLink';

interface SchippingDratailsProp {
  data: any;
  apiBase: string;
}

export default class SchippingDratails extends React.Component<SchippingDratailsProp> {
  render(): React.ReactNode {
    return (
      <div>
        <table>
          <thead>
            <tr>
              <th>Position</th>
              <th>EAN</th>
              <th>Menge</th>
              <th>Bestelung</th>
            </tr>
          </thead>
          <tbody>
            {this.props.data.position.map((item, index) => {
              let key = 'data_' + index;
              let classNameRow = 'row' + (index % 2 == 1 ? ' mod2' : '');
              let itemLink =
                '/konto/mol_orders/' +
                item.mol_auftrag_id +
                '#pos_' +
                item.mol_auftrag_position_id;

              return (
                <tr id={'ean_' + item.ean} key={key} className={classNameRow}>
                  <td>{item.pos_bezeichnung}</td>
                  <td>{item.ean}</td>
                  <td>{item.liefer_menge}</td>
                  <td>
                    <MolLink to={itemLink} href={itemLink}>
                      {item.mol_auftrag_id}
                    </MolLink>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  }

  componentDidMount(): void {
    let winAny: any = window;
    let location = winAny.historyHelper.memory.location;
    let urlParams = new URLSearchParams(location.search);
    let ean = urlParams.get('ean') ?? '';
    if (ean != '') {
      let item: any = document.getElementById('ean_' + ean);
      item.classList.add('activ');
      var rect = item.getBoundingClientRect();
      winAny.scrollTo(0, rect.top);
    }
  }
}
